export const CLASSIC_KEY = 'sqr.classic';
const base = () => (process.env.REACT_APP_NEW_CABINET_URL || '').replace(/\/+$/, '');
export const newCabinetEnabled = () => Boolean(base());
export function newCabinetUrl(menuJwt, next = '/') {
  if (!base() || !menuJwt) return '';
  return `${base()}/auth/callback?token=${encodeURIComponent(menuJwt)}&next=${encodeURIComponent(next)}`;
}
export function preferClassic() { try { return window.localStorage.getItem(CLASSIC_KEY) === '1'; } catch (e) { return false; } }
export function rememberClassic(search) {
  if (!/(^\?|&)classic=1(&|$)/.test(search || '')) return false;
  try { window.localStorage.setItem(CLASSIC_KEY, '1'); } catch (e) { /* private mode */ }
  return true;
}
export function forgetClassic() { try { window.localStorage.removeItem(CLASSIC_KEY); } catch (e) { /* ignore */ } }
export const shouldRedirectToNewCabinet = search => newCabinetEnabled() && !rememberClassic(search) && !preferClassic();
